import { render } from "./vyingbinew.vue?vue&type=template&id=6f2eb138&scoped=true"
import script from "./vyingbinew.vue?vue&type=script&lang=js"
export * from "./vyingbinew.vue?vue&type=script&lang=js"

import "./vyingbinew.vue?vue&type=style&index=0&id=6f2eb138&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2eb138"]])

export default __exports__